<script setup lang="ts">
import { ButtonProps } from '~/components/ui/Button.vue'
import { ModalVariants } from '~/components/ui/Modal.vue'
import { ProductCarouselProps } from '../ProductCarousel/ProductCarousel.vue'

type ActionModalProps = {
  button: ButtonProps
  modalContent: ProductCarouselProps
  modalVariant: ModalVariants
}
const props = defineProps<ActionModalProps>()
const attrs = useAttrs() /* Atts may include gaOptions, other HTML button attrs like: class, aria-label */
const isShowModal = ref(false)
// Mount the content on first open: Modal only v-shows its slot, so it would otherwise render (and fetch) on page load.
const hasOpened = ref(false)
const openModal = () => {
  hasOpened.value = true
  isShowModal.value = true
}
</script>

<template>
  <Button class="product-list-modal__button" @click.prevent="openModal" v-bind="{ ...button, ...attrs }">
    <slot />
  </Button>
  <ClientOnly>
    <Teleport to="body">
      <Modal :variant="modalVariant" :show="isShowModal" @close="isShowModal = false" class="product-list-modal__modal">
        <CMSProductList v-if="hasOpened" v-bind="modalContent" />
      </Modal>
    </Teleport>
  </ClientOnly>
</template>

<style></style>
